//@flow
import React from 'react';
import { Container } from 'flux/utils';
import { LoadingSpinner } from './LoadingButton.react';
import ShellStore from '../../Stores/Shell/shell';

type State = {
  isLoading:boolean,
};

class LoadingWrapper extends React.Component<Object, State> {
  static getStores() {
    return [
      ShellStore,
    ];
  }

  static calculateState(prevState:State):State {
    return {
      isLoading: ShellStore.isLoading(),
    };
  }

  render() {
    if (!this.state.isLoading) return null;

    return (<LoadingSpinner />);
  }
}

export default Container.create(LoadingWrapper);
